export default "__VITE_ASSET__9d6276ff__"